import { customDevelopment } from '../content/site';
import SectionHeading from './SectionHeading';

export default function CustomDevelopment() {
  return (
    <section id="custom-development" className="bg-cream py-24">
      <div className="container-page">
        <SectionHeading
          eyebrow={customDevelopment.eyebrow}
          heading={customDevelopment.heading}
          align="center"
        />
        <p className="mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed text-ink-soft">
          {customDevelopment.description}
        </p>

        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          {customDevelopment.capabilities.map((item, i) => (
            <article
              key={item.title}
              className="rounded-xl2 border border-ink/5 bg-cream-alt p-6 shadow-soft transition-transform hover:-translate-y-1"
            >
              <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-gold/15 font-display text-dusk">
                {i + 1}
              </div>
              <h3 className="text-lg font-display text-ink">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-soft">{item.description}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href={customDevelopment.cta.href}
            className="inline-flex rounded-full bg-coral px-6 py-3 text-sm font-semibold text-cream shadow-soft transition-colors hover:bg-coral-dark"
          >
            {customDevelopment.cta.label}
          </a>
        </div>
      </div>
    </section>
  );
}
